import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import CartDrawer from './components/CartDrawer';
import './App.css';

const { FiShoppingBag, FiX, FiMinus, FiPlus } = FiIcons;

function App() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [email, setEmail] = useState('');

  // PLACEHOLDER IMAGES - Replace these with your local files in public/images/
  // Example: image: "/images/lia-hoodie-protect.jpg"
  const HOODIE_IMG = "https://images.unsplash.com/photo-1578768079052-aa76e52ff62e?w=800&q=80";
  const HAT_IMG = "https://images.unsplash.com/photo-1575428652377-a2d80e2277fc?w=800&q=80";

  const products = [
    {
      id: 1,
      name: "Protect Your Peace",
      subtitle: "F*ck Off Edition Hoodie",
      price: 89,
      image: HOODIE_IMG,
      inStock: true,
      tag: "BESTSELLER"
    },
    {
      id: 2,
      name: "Social F*ck Off",
      subtitle: "LIA Core Hoodie",
      price: 89,
      image: HOODIE_IMG,
      inStock: true
    },
    {
      id: 3,
      name: "Pixel Finger",
      subtitle: "Back Print Hoodie",
      price: 95,
      image: HOODIE_IMG,
      inStock: false
    },
    {
      id: 4,
      name: "Pixel Mood",
      subtitle: "Embroidered Dad Hat",
      price: 45,
      image: HAT_IMG,
      inStock: true
    },
    {
      id: 5,
      name: "LIA* Signature",
      subtitle: "Serif Logo Cap",
      price: 45,
      image: HAT_IMG,
      inStock: true
    },
    {
      id: 6,
      name: "Social Battery: Alone",
      subtitle: "Status Cap",
      price: 45,
      image: HAT_IMG,
      inStock: true
    },
    {
      id: 7,
      name: "Leave Intro Today",
      subtitle: "Script Script Cap",
      price: 45,
      image: HAT_IMG,
      inStock: true
    },
    {
      id: 8,
      name: "Neon Finger",
      subtitle: "Limited Green Edition",
      price: 55,
      image: HAT_IMG,
      inStock: true,
      tag: "LIMITED"
    },
    {
      id: 9,
      name: "F*ck Off",
      subtitle: "Rear Strap Detail Cap",
      price: 45,
      image: HAT_IMG,
      inStock: true
    }
  ];

  const addToCart = (product) => {
    if (!product.inStock) return;
    setCartItems(prev => {
      const existing = prev.find(item => item.id === product.id);
      if (existing) {
        return prev.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
    setIsCartOpen(true);
  };

  const updateQuantity = (id, newQuantity) => {
    if (newQuantity === 0) {
      setCartItems(prev => prev.filter(item => item.id !== id));
    } else {
      setCartItems(prev =>
        prev.map(item =>
          item.id === id ? { ...item, quantity: newQuantity } : item
        )
      );
    }
  };

  const getTotalPrice = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    if (email) {
      alert('Added to Do Not Disturb list ✓');
      setEmail('');
    }
  };

  return (
    <div className="app">
      {/* Navigation */}
      <motion.nav 
        className="nav"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="nav-content">
          <div className="logo">LIA</div>
          <button 
            className="cart-button"
            onClick={() => setIsCartOpen(true)}
          >
            <SafeIcon icon={FiShoppingBag} />
            {cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </button>
        </div>
      </motion.nav>

      {/* Hero Section */}
      <motion.section 
        className="hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="noise-overlay"></div>
        <div className="hero-content">
          <motion.h1 
            className="hero-title"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            PROTECT YOUR PEACE
          </motion.h1>
          <motion.button 
            className="hero-button"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })}
          >
            [ENTER THE SILENCE]
          </motion.button>
        </div>
      </motion.section>

      {/* Products Section */}
      <motion.section 
        id="products"
        className="products"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="products-content">
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            THE DROP
          </motion.h2>
          <div className="products-grid">
            {products.map((product, index) => (
              <motion.div 
                key={product.id}
                className={`product-card ${!product.inStock ? 'out-of-stock' : ''}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={product.inStock ? { y: -5 } : {}}
              >
                <div className="product-image-container">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="product-image"
                  />
                  {product.inStock && (
                    <div className="product-overlay">
                      <button 
                        className="add-to-cart-btn"
                        onClick={() => addToCart(product)}
                      >
                        ADD TO CART
                      </button>
                    </div>
                  )}
                  {product.tag && (
                    <div className="product-tag">
                      {product.tag}
                    </div>
                  )}
                  {!product.inStock && (
                    <div className="sold-out-overlay">
                      <span>SOLD OUT</span>
                    </div>
                  )}
                </div>
                <div className="product-info">
                  <div className="product-header">
                    <h3 className="product-name">{product.name}</h3>
                    <p className="product-price">${product.price}</p>
                  </div>
                  <p className="product-subtitle">{product.subtitle}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* Manifesto Section */}
      <motion.section 
        className="manifesto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <motion.div 
          className="manifesto-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="manifesto-text">
            For those who find power in the quiet.<br />
            Leave Introverts Alone.
          </h2>
        </motion.div>
      </motion.section>

      {/* Footer */}
      <motion.footer 
        className="footer"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="footer-content">
          <div className="footer-links">
            <a href="#" className="footer-link">SHIPPING</a>
            <a href="#" className="footer-link">PRIVACY</a>
          </div>
          <form className="email-signup" onSubmit={handleEmailSubmit}>
            <input
              type="email"
              placeholder="Join the Do Not Disturb list"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="email-input"
              required
            />
            <button type="submit" className="email-submit">→</button>
          </form>
        </div>
      </motion.footer>

      {/* Cart Drawer */}
      <CartDrawer
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        items={cartItems}
        onUpdateQuantity={updateQuantity}
        totalPrice={getTotalPrice()}
      />
    </div>
  );
}

export default App;